/* eslint-disable camelcase */
import api from '../utils/API';
import { API_URLS } from '../constants/api_urls';

export class PortfolioService {
  static async getAll(clientId) {
    return await api.get(`${API_URLS.ACCOUNTS_V3}/${clientId}/portfolio`, {
      params: { limit: -1, offset: 0 },
    });
  }

  static async getById(portfolioId) {
    return await api.get(`${API_URLS.PORTFOLIO_V3}/${portfolioId}`);
  }

  static async getPortfolioHistory(portfolioId) {
    return await api.get(
      `${API_URLS.PORTFOLIO_HISTORY}/${portfolioId}/history`,
    );
  }

  static async createPortfolioFull(data) {
    return await api.post(API_URLS.PORTFOLIO_V3, data);
  }

  static async createPortfolioDraft(values) {
    return await api.post(API_URLS.CREATE_PORTFOLIO_DRAFT, values);
  }

  //TODO
  static async updatePortfolio(id, data) {
    return await api.put(`${API_URLS.PORTFOLIO_V3}/${id}`, data);
  }

  static async deleteById(id) {
    return await api.delete(`${API_URLS.PORTFOLIO_V3}/${id}`);
  }

  static async search(value, type) {
    return await api.get(API_URLS.SEARCH, {
      params: { searchParam: value, limit: 20, offset: 0, include_in_ib: type },
    });
  }

  static async portfolioExport(id) {
    const format = { format: 'xlsx' };
    return await api.post(`${API_URLS.EXPORT_PORTFOLIO}/${id}/export`, format, {
      responseType: 'arraybuffer',
    });
  }

  static async selectedPortfolioExport(data) {
    const {
      format: { key },
      portfolio_ids,
    } = data;
    return await api.post(
      `${API_URLS.SELECTED_EXPORT}`,
      { format: key, portfolio_ids },
      { responseType: 'arraybuffer' },
    );
  }

  static async portfolioImport(file) {
    const bodyFormData = new FormData();
    bodyFormData.append('file', file);

    return await api.post(API_URLS.IMPORT_PORTFOLIO, bodyFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  static async getReports(id) {
    return await api.get(`${API_URLS.REPORTS}/${id}/reports`, {
      params: { limit: 100, offset: 0 },
    });
  }

  static async reportDownload(reportId) {
    return await api.get(
      `${API_URLS.DOWNLOAD_REPORT_V2}/${reportId}/download`,
      {
        responseType: 'arraybuffer',
      },
    );
  }

  static async reportCreate(data) {
    const { id, name } = data;

    const bodyFormData = new FormData();
    const report = document.querySelector('#report');

    bodyFormData.append('portfolioID', id);
    bodyFormData.append('reportName', name);
    bodyFormData.append('file', report.files[0]);

    return await api.post(API_URLS.CREATE_REPORT, bodyFormData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }

  static async getHistoryById(id) {
    return await api.get(`${API_URLS.PORTFOLIO_HISTORY}/${id}/history`);
  }

  static async optimizationPortfolio(id) {
    return await api.put(`${API_URLS.OPTIMIZATION}/${id}/requestOptimization`);
  }

  static async portfolioTaskProspecting({ portfolioId, data }) {
    return await api.post(
      `${API_URLS.OPTIMIZATION_V3}/${portfolioId}/prospect`,
      data,
    );
  }

  static async createPortfolioCurrentAnalysis({ portfolioId, data }) {
    return await api.post(
      `${API_URLS.OPTIMIZATION_V3}/${portfolioId}/analysis`,
      data,
    );
  }

  static async portfolioTaskAnalysis({
    portfolioId,
    name,
    fees,
    include_financial_plan,
  }) {
    return await api.get(
      `${API_URLS.OPTIMIZATION}/${portfolioId}/prospect/${name}/analysis`,
      { params: { ...fees, include_financial_plan } },
    );
  }

  static async postStepOptimisationPortfolio({ portfolioId, data }) {
    return await api.post(
      `${API_URLS.OPTIMIZATION}/${portfolioId}/optimisation/state`,
      data,
    );
  }

  static async getStepOptimisationPortfolio({ portfolioId }) {
    return await api.get(
      `${API_URLS.OPTIMIZATION}/${portfolioId}/optimisation/state`,
    );
  }

  static async sendFinancialPlan({ portfolioId, data }) {
    return await api.post(
      `${API_URLS.PORTFOLIO}/${portfolioId}/financial/plan`,
      data,
    );
  }

  static async portfolioFinalrequest(data) {
    const { portfolioId, name, item } = data;
    return await api.post(
      `${API_URLS.OPTIMIZATION}/${portfolioId}/prospect/${name}/apply`,
      item,
    );
  }

  static async sendDataPDFportfolio(data) {
    const { portfolioId, array } = data;
    return await api.post(
      `${API_URLS.OPTIMIZATION_V2}/${portfolioId}/optimisation/result`,
      array,
    );
  }

  static async downloadTEMP() {
    return await api.get(API_URLS.DOWNLOAD_TEMP, {
      responseType: 'arraybuffer',
    });
  }

  static async getCandidates(portfolioId) {
    return await api.get(`${API_URLS.PORTFOLIO}/${portfolioId}/candidates`);
  }

  static async getTransactions({ portfolioId, candidatId }) {
    return await api.get(
      `/v1/portfolio/${portfolioId}${API_URLS.CANDIDATE}/${candidatId}/transactions`,
    );
  }

  static async getAvailablePortfolioCode(data) {
    const { advisorId } = data;
    return await api.get(`/v1/advisor/${advisorId}/portfolio`);
  }

  static async getPreCandidate(data) {
    const { portfolioId, transactionId } = data;
    return await api.get(
      `/v1/portfolio/${portfolioId}/precandidate/${transactionId}`,
    );
  }

  static async getGatherURL(id) {
    return await api.post(`/v2/gather/${id}/create-load-url`);
  }

  static async getGatherCanLoad(id) {
    return await api.get(`/v2/gather/${id}/can-load`);
  }

  static async getHistoricalData(id) {
    return await api.get(`v3/portfolio/${id}/historical`);
  }

  static async setPortfolioColor(data) {
    const { portfolioId, color } = data;
    return await api.put(`v3/portfolio/${portfolioId}/color`, { color });
  }

  static async getReportTypeList(id) {
    return await api.get(`v3/portfolio/${id}/optimisation/report/types`);
  }

  static async revertSuggestions(id) {
    return await api.post(`v3/offers/${id}/revert`);
  }
}
